import FieldWithInputRadios from './FieldWithInputRadios'

export default FieldWithInputRadios



// WEBPACK FOOTER //
// ./src/components/FieldWithInputRadios/index.js